import React from "react";
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import billersData from '../../config/liveBillers.json';
import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Typography,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";

const BillDetails = () => {
    const location = useLocation();
    const { selectedApp, setSelectedApp } = location.state || ''; // Retrieve passed state
    const [number, setNumber] = useState('');
    const [amount, setAmount] = useState('');
    const navigate = useNavigate();
    const [billers, setBillers] = useState([]);
    const [selectedBiller, setSelectedBiller] = useState('');

  // Lazy load the JSON file
  useEffect(() => {
    const loadBillers = async () => {
      try {
        const response = await import("../../config/liveBillers.json");
        setBillers(response.default.filter((biller) => biller.Billers.toUpperCase() === selectedApp));
      } catch (error) {
        console.error("Error loading billers:", error);
      }
    };

    loadBillers();
  }, []);

  // Handle form submission
  const handlePay = () => {
    if (selectedBiller && number && amount) {
      // Redirect to a different page with query parameters
      //navigate(`/payment-confirm/${selectedBiller}/${number}/${amount}`);
       // Pass values secretly using state
      navigate("/payment-confirm", {
        state: { selectedBiller, number, amount },
      });
    } else {
      alert('Please fill all fields before proceeding.');
    }
  };
    return (
    <div className="bg-container">
        <Header />
        <Box
          sx={{
            maxWidth: 500,
            margin: "150",
            padding: 4,
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: "#f9f9f9",
          }}
        >
          <Typography variant="h4" gutterBottom align="center">
            Fetch Bill
          </Typography>
          

      {/* Dropdown for Biller Name */}
      <FormControl fullWidth sx={{ marginBottom: 2 }}>
        <InputLabel id="biller-label">Biller Name</InputLabel>
        <Select
          labelId="biller-label"
          id="selectedBiller"
          value={selectedBiller}
          onChange={(e) => setSelectedBiller(e.target.value)}
          label="Biller Name"
        >
          {billers.map((biller, index) => (
            <MenuItem key={index} value={biller["Biller Name"]}>
              {biller["Biller Name"]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Input for Number */}
      <TextField
        fullWidth
        label={`${selectedBiller} A/C No.`}
        variant="outlined"
        value={number}
        onChange={(e) => setNumber(e.target.value)}
        placeholder="Enter your number"
        sx={{ marginBottom: 2 }}
      />

      {/* Input for Amount */}
      <TextField
        fullWidth
        label="OSCB Registered Phone number"
        type="tel"
        variant="outlined"
        value={amount}
        onChange={(e) => {
          const value = e.target.value;
          // Allow only numbers and limit to 10 digits
          if (/^\d{0,10}$/.test(value)) {
            setAmount(value);
          }
        }}
        placeholder="Enter phone number"
        sx={{ marginBottom: 2 }}
        slotProps={{
          input: {
            maxLength: 10, // Limit input to 10 characters
          },       
      }}
      />

      {/* Pay Button */}
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={handlePay}
        sx={{ padding: 1 }}
      >
        PROCEED
      </Button>
    </Box>
    </div>
    );
};

export default BillDetails;